import Client from './client';

export default class StripeEvents extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  postStripe(options = {}) {
    return this.makeRequest(`${this.host}/payment/callbacks/stripe`, {
      ...options,
       method: 'POST',
    });
  }

}
